const now = () => new Date().toISOString();

export const DEMO_ADMIN = {
  email: "admin@atelier.store",
  password: "Admin@12345",
};

export const DEMO_PRODUCTS = [
  {
    id: "a1000001-0000-4000-8000-000000000001",
    name: "Noir Cashmere Overcoat",
    description: "A tailored double-breasted overcoat in 100% Mongolian cashmere.",
    price: 24999,
    discount_percent: 0,
    category: "women",
    brand: "Atelier Noir",
    material: "100% Cashmere",
    sizes: ["XS", "S", "M", "L"],
    colors: ["Black", "Ivory"],
    images: [
      "https://images.unsplash.com/photo-1544022613-e87ca75a784a?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1520975916090-3105956dac38?auto=format&fit=crop&w=1200&q=80",
    ],
    stock: 12,
    featured: true,
    created_at: "2026-01-15T10:00:00.000Z",
  },
  {
    id: "a1000002-0000-4000-8000-000000000002",
    name: "Sculpted Wool Trouser",
    description: "High-rise wide-leg trousers cut from virgin Italian wool.",
    price: 8990,
    discount_percent: 10,
    category: "women",
    brand: "Atelier Noir",
    material: "Virgin Wool",
    sizes: ["S", "M", "L", "XL"],
    colors: ["Charcoal", "Camel"],
    images: ["https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?auto=format&fit=crop&w=1200&q=80"],
    stock: 20,
    featured: true,
    created_at: "2026-01-14T10:00:00.000Z",
  },
  {
    id: "a1000003-0000-4000-8000-000000000003",
    name: "Monogram Silk Shirt",
    description: "Sand-washed silk shirt with a relaxed drape.",
    price: 12500,
    discount_percent: 0,
    category: "women",
    brand: "Atelier Noir",
    material: "100% Silk",
    sizes: ["XS", "S", "M", "L"],
    colors: ["Ivory", "Onyx"],
    images: ["https://images.unsplash.com/photo-1551803091-e20673f15770?auto=format&fit=crop&w=1200&q=80"],
    stock: 15,
    featured: false,
    created_at: "2026-01-13T10:00:00.000Z",
  },
  {
    id: "a1000004-0000-4000-8000-000000000004",
    name: "Milano Wool Suit",
    description: "Two-piece suit in super-120s wool.",
    price: 34999,
    discount_percent: 5,
    category: "men",
    brand: "Atelier Noir",
    material: "Super 120s Wool",
    sizes: ["S", "M", "L", "XL"],
    colors: ["Midnight", "Charcoal"],
    images: [
      "https://images.unsplash.com/photo-1594938298603-c8148c4dae35?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1617137968427-85924c800a22?auto=format&fit=crop&w=1200&q=80",
    ],
    stock: 8,
    featured: true,
    created_at: "2026-01-12T10:00:00.000Z",
  },
  {
    id: "a1000005-0000-4000-8000-000000000005",
    name: "Vintage Denim Trouser",
    description: "Selvedge denim woven in Okayama.",
    price: 7200,
    discount_percent: 0,
    category: "men",
    brand: "Atelier Noir",
    material: "Selvedge Denim",
    sizes: ["30", "32", "34", "36"],
    colors: ["Indigo"],
    images: ["https://images.unsplash.com/photo-1542272604-787c3835535d?auto=format&fit=crop&w=1200&q=80"],
    stock: 25,
    featured: false,
    created_at: "2026-01-11T10:00:00.000Z",
  },
  {
    id: "a1000006-0000-4000-8000-000000000006",
    name: "Alpine Merino Knit",
    description: "Ribbed merino wool sweater.",
    price: 6800,
    discount_percent: 0,
    category: "men",
    brand: "Atelier Noir",
    material: "Merino Wool",
    sizes: ["S", "M", "L", "XL"],
    colors: ["Bone", "Slate", "Espresso"],
    images: ["https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80"],
    stock: 30,
    featured: true,
    created_at: "2026-01-10T10:00:00.000Z",
  },
  {
    id: "a1000007-0000-4000-8000-000000000007",
    name: "Leather Card Holder",
    description: "Slim card holder in Italian vegetable-tanned leather.",
    price: 4800,
    discount_percent: 0,
    category: "accessories",
    brand: "Atelier Noir",
    material: "Italian Leather",
    sizes: ["One Size"],
    colors: ["Cognac", "Black"],
    images: ["https://images.unsplash.com/photo-1627123424574-724758594e93?auto=format&fit=crop&w=1200&q=80"],
    stock: 50,
    featured: false,
    created_at: "2026-01-09T10:00:00.000Z",
  },
  {
    id: "a1000008-0000-4000-8000-000000000008",
    name: "Structured Tote Bag",
    description: "Architectural tote in smooth calf leather.",
    price: 18900,
    discount_percent: 0,
    category: "accessories",
    brand: "Atelier Noir",
    material: "Calfskin Leather",
    sizes: ["One Size"],
    colors: ["Black", "Bone"],
    images: ["https://images.unsplash.com/photo-1584917865442-de89df76afd3?auto=format&fit=crop&w=1200&q=80"],
    stock: 10,
    featured: true,
    created_at: "2026-01-08T10:00:00.000Z",
  },
];

export const DEMO_COUPONS = [
  {
    id: "c1000001-0000-4000-8000-000000000001",
    code: "WELCOME10",
    kind: "percent",
    value: 10,
    min_order: 2000,
    active: true,
    created_at: "2026-01-01T10:00:00.000Z",
  },
  {
    id: "c1000002-0000-4000-8000-000000000002",
    code: "FLAT500",
    kind: "flat",
    value: 500,
    min_order: 5000,
    active: true,
    created_at: "2026-01-01T10:00:00.000Z",
  },
];

export const DEMO_SAMPLE_REVIEWS = [
  {
    id: "r1000001-0000-4000-8000-000000000001",
    product_id: "a1000001-0000-4000-8000-000000000001",
    user_id: "demo-user-1",
    user_name: "Priya S.",
    rating: 5,
    title: "Absolutely stunning",
    body: "The cashmere is incredibly soft and the fit is perfect. Worth every rupee.",
    created_at: "2026-02-01T10:00:00.000Z",
  },
  {
    id: "r1000002-0000-4000-8000-000000000002",
    product_id: "a1000004-0000-4000-8000-000000000004",
    user_id: "demo-user-2",
    user_name: "Rahul M.",
    rating: 4,
    title: "Sharp tailoring",
    body: "Great suit for business meetings. Slightly long on the sleeves but easily fixed.",
    created_at: "2026-02-05T10:00:00.000Z",
  },
];

export const DEMO_SAMPLE_ORDERS = [
  {
    id: "o1000001-0000-4000-8000-000000000001",
    user_id: "u1000001-0000-4000-8000-000000000099",
    user_email: "demo@example.com",
    is_guest: false,
    items: [
      {
        product_id: "a1000008-0000-4000-8000-000000000008",
        name: "Structured Tote Bag",
        image: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?auto=format&fit=crop&w=1200&q=80",
        unit_price: 18900,
        quantity: 1,
        size: "One Size",
        color: "Black",
        line_total: 18900,
      },
    ],
    shipping: {
      full_name: "Demo Customer",
      phone: "9876543210",
      line1: "12 MG Road",
      line2: "",
      city: "Bengaluru",
      state: "Karnataka",
      pincode: "560001",
      country: "India",
    },
    subtotal: 18900,
    coupon_code: null,
    discount: 0,
    amount: 18900,
    amount_paise: 1890000,
    currency: "INR",
    razorpay_order_id: "mock_order_demo001",
    razorpay_payment_id: "mock_pay_demo001",
    status: "delivered",
    created_at: "2026-02-20T10:00:00.000Z",
    paid_at: "2026-02-20T10:05:00.000Z",
    mock: true,
  },
];

export const DEMO_STATS = {
  total_products: DEMO_PRODUCTS.length,
  total_users: 24,
  total_orders: 18,
  paid_orders: 15,
  revenue: 284500,
  mock_payment_mode: true,
};

export { now };
